export default __webpack_public_path__ + "static/media/relogio.87c71952.svg";